<template>
  <section class="service">
    <h2>服务保障</h2>
    <div class="serviceBox">
      <div class="item" v-for="(item,index) in items" :key="index">
        <p>{{item.name}}</p>
        <p>{{item.desc}}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { name: "价格保护", desc: "官方合作报价" },
        { name: "数据安全", desc: "所有数据 深度粉碎" },
        { name: "品牌信任", desc: "强强联合 信任无忧" },
        { name: "专业质检", desc: "标准化专业检测团队" }
      ]
    };
  }
};
</script>

<style scoped>
.service {
  width: 3.48rem;
  margin: 0.1rem auto 0rem;
}
.service h2 {
  text-align: center;
  font-size: 0.16rem;
}
.serviceBox {
  display: flex;
  flex-flow: wrap;
  margin: 0.2rem 0 0 0;
}
.serviceBox .item {
  position: relative;
  width: 1.65rem;
  height: 0.68rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 0.04rem 0px rgba(134, 130, 130, 0.3);
  border-radius: 0.05rem;
  padding:0.14rem 0 0 0.53rem;
  margin-bottom:0.19rem
}
.serviceBox .item::before {
  display: inline-block;
  content: "";
  width: 0.28rem;
  height: 0.28rem;
  background: url(../../../assets/image/service_icon.png) 0rem 0rem
    no-repeat;
  background-size: 1.06rem;
  position: absolute;
  left: 0.12rem;
  top: 0.2rem;
}
.serviceBox .item:nth-child(2)::before {
  background-position: -0.26rem 0rem;
}
.serviceBox .item:nth-child(3)::before {
  background-position: -0.55rem 0rem;
}
.serviceBox .item:nth-child(4)::before {
  background-position: -0.83rem 0rem;
}
.serviceBox .item:nth-child(2n) {
  margin-left: 0.16rem;
}
.serviceBox .item p:nth-child(1) {
  font-size: 0.14rem;
}
.serviceBox .item p:nth-child(2) {
  font-size: 0.12rem;
  color: #999;
  margin-top: 0.07rem;
}
</style>
